<app-progress-bar *ngIf="loading"></app-progress-bar>
<div *ngIf="!loading" class="row mt-1">
    <div class="col-lg-4 offset-lg-4">
        <div class="card text-white bg-secondary mb-3" style="max-width: 25rem;">
            <div class="card-header text-center">{{ operacion }} Carrera</div>
            <div class="card-body">
                <form [formGroup]="form" (ngSubmit)="addManagment()">
                    <input formControlName="name" type="text" class="form-control" placeholder="Ingrese nombre">
                    <span *ngIf="form.get('name')?.hasError('required') && form.get('name')?.touched">
                        El campo nombre es <strong>requerido</strong>
                    </span>
                    <select formControlName="state" class="form-control mt-2" placeholder="Seleccione estado de inicio">
                        <option value="null" disabled selected>Seleccione estado de inicio</option>
                        <option value="0">Inactivo</option>
                        <option value="1">Activo</option>
                      </select>
                      <span *ngIf="form.get('state')?.hasError('required') && form.get('state')?.touched">
                        El campo estado es <strong>requerido</strong>
                      </span>
                      
                    <div class="row mt-2 text-center">
                        <div class="col-lg-6">
                            <button routerLink="/managment" type="button" class="btn btn-secondary">Volver</button>
                        </div>
                        <div class="col-lg-6">
                            <button  [disabled]="form.invalid" type="submit" class="btn btn-primary">Aceptar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>